import React, { useEffect, useState } from "react";
import InvoiceScreen from "./InvoiceScreen";
import InvoiceScreenMobile from "./InvoiceScreenMobile";

export default function ResponsiveInvoiceScreen() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile ? <InvoiceScreenMobile /> : <InvoiceScreen />;
}